export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14233.2858f057.jpg";